const API_CONFIG = {
    TRAFFIC_DATA: {
        queryKey: "search-overview-traffic-data",
        endpoint: "/api/searchoverview/overview/traffic",
    },
    KEYWORDS_DATA: {
        queryKey: "search-overview-keywords-data",
        endpoint: "/api/searchoverview/overview/keywords",
    },
    RANK_DISTRIBUTION_DATA: {
        queryKey: "search-overview-rank-distribution-data",
        endpoint: "api/searchoverview/keywords/rank-distribution",
    },
    BRANDED_SPLIT_DATA: {
        queryKey: "search-overview-branded-split-data",
        endpoint: "/api/searchoverview/keywords/brand-split",
    },
};
export const apiHooks = {
    useTrafficData: API_CONFIG.TRAFFIC_DATA,
    useOrganicKeywordsData: API_CONFIG.KEYWORDS_DATA,
    usePaidKeywordsData: API_CONFIG.KEYWORDS_DATA,
    useRankDistributionData: API_CONFIG.RANK_DISTRIBUTION_DATA,
    useBrandedSplitData: API_CONFIG.BRANDED_SPLIT_DATA,
};
